import { type FC, useCallback, useState } from 'react';

import Collapse from '@mui/material/Collapse';
import { type Booking, type MicroCopy, type Search } from '@vakantiesnl/types/src';

import { useCustomStyles } from './Flight.styles';
import { FlightTransfer } from '../FlightTransfer';
import { Flight } from './Flight';

export type FlightWithStopOverProps = {
	flight: Search.Flight | Booking.Flight;
	isOutbound?: boolean;
	microCopies: MicroCopy;
	isTransfer?: boolean;
	hasToggleStopOver?: boolean;
	showLeadingAirPlaneIcons?: boolean;
	showTitle?: boolean;
};

export const FlightWithStopOver: FC<FlightWithStopOverProps> = (props) => {
	const { flight, hasToggleStopOver } = props;
	const { classes } = useCustomStyles();

	const hasStopOver = 'stopOver' in flight && flight.stopOver !== 0;

	const [showStopOver, setShowStopOver] = useState(!hasToggleStopOver && hasStopOver ? true : false);

	const toggleStopOver = useCallback(() => {
		setShowStopOver((prev) => !prev);
	}, []);

	const handleStopOver = !hasToggleStopOver || !hasStopOver ? undefined : toggleStopOver;

	return (
		<>
			<Flight {...props} toggleStopOver={handleStopOver} />
			<Collapse in={showStopOver} timeout={'auto'} unmountOnExit>
				<div className={classes.transferBlock}>
					<FlightTransfer flight={flight} isOutbound={true} />
				</div>
			</Collapse>
		</>
	);
};
